import { render, staticRenderFns } from "./Tarifas.vue?vue&type=template&id=4466d238&scoped=true"
import script from "./Tarifas.vue?vue&type=script&lang=js"
export * from "./Tarifas.vue?vue&type=script&lang=js"
import style0 from "./Tarifas.vue?vue&type=style&index=0&id=4466d238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4466d238",
  null
  
)

export default component.exports